import * as React from 'react';
import { useModal } from '../Context/Context';
import S from './Background.styles';
const Background = () => {
    const modal = useModal();
    return (React.createElement(S.Background, { "data-close": modal.closeOnBackground, "aria-hidden": true, onClick: modal.closeOnBackground
            ? (event) => {
                event.preventDefault();
                modal.onClose();
            }
            : undefined, variants: { open: { opacity: 1 }, closed: { opacity: 0 } }, initial: "closed", animate: "open", exit: "closed" }));
};
export default Background;
